import React, { Component } from "react"

import DeleteModal from "./DeleteModal"
import SpinnerImage from "./SpinnerImage"
import WidgetHeaderButton from "./WidgetHeaderButton"

class ViewFormActionButtonsWidget extends Component {
    state = {
        isModalOpen: false,
    }

    handleDelete = (activeId) => () => {
        this.props.onDelete(activeId)
        this.setState({ isModalOpen: false })
    }

    toggle = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen })
    }

    render() {
        const {
            canEdit,
            canDelete,
            showDelete,
            children,
            activeId,
            isDeleting,
            name,
            onEdit,
            type,
        } = this.props

        return (
            <div className="widget small-widget-padding">
                <div className="widget-header">
                    <div className="save-buttons pull-right">
                        {isDeleting && <SpinnerImage />}
                        {children}
                        {showDelete && (
                            <span>
                                <WidgetHeaderButton
                                    isSecondary={true}
                                    disabled={!canDelete}
                                    onClick={this.toggle}
                                >
                                    Delete
                                </WidgetHeaderButton>
                                <DeleteModal
                                    isOpen={this.state.isModalOpen}
                                    name={name}
                                    type={type}
                                    onDelete={this.handleDelete(activeId)}
                                    toggle={this.toggle}
                                />
                            </span>
                        )}
                        <WidgetHeaderButton
                            disabled={!canEdit}
                            onClick={onEdit}
                        >
                            Edit
                        </WidgetHeaderButton>
                    </div>
                </div>
            </div>
        )
    }
}
export default ViewFormActionButtonsWidget
